'use client';

import type { PropsWithChildren } from 'react';

import { withPromo } from '@/helpers/hocs';
import { SCRATCH_GAME_RESTRICTED_GROUPS } from '@/modules/promotions';

function ScratchGamePage({ children }: PropsWithChildren) {
  return children;
}

export default withPromo(ScratchGamePage, {
  redirectUrl: '/',
  promoName: 'scratchGame',
  restrictedGroups: SCRATCH_GAME_RESTRICTED_GROUPS,
});
